<div class="close-icon" (click)="close()" *appFeatureToggle="'desktop'" role="button" tabindex="0">
    <img style="height: 25px" src="{{ DEPLOY_URL }}/assets/images/cross.svg" alt="cross" />
</div>

<div class="heading">
    <span class="title">Would you like to repeat customization?</span>
    <span class="product-label">{{ product.label }}</span>
    <span class="product-subcategory">{{ product.subcategory_name }}</span>
</div>

@if (isObject(data?.description)) {
    <div class="combo-description">
        @for (desc of getObjectKeys(data?.description); track desc) {
            <div class="description-container">
                <div
                    class="desc-icon"
                    [ngClass]="{ veg: data?.description[desc].veg, 'non-veg': !data?.description[desc].veg }"></div>
                <span class="product-description">{{ data?.description[desc].label.join(', ') }}</span>
            </div>
        }
    </div>
} @else {
    <p class="product-description">{{ data.description }}</p>
}

<div class="button-container">
    <button btn-primary-border (click)="submit('add-new')">Add New</button>
    <button btn-primary (click)="submit('repeat-last')">Repeat Last</button>
</div>
